import { client } from '../client';
import Endpoints from '../Endpoints';
import { getData } from '../apiUtils';

export default async function getS3Url(payload: any) {
    return client.post(`${Endpoints.s3URL}`, payload).then(getData);
}
